module.exports = __webpack_public_path__ + "static/assets/success.b05c532.png";